import React from 'react';
import { ComposedChart, Bar, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { money } from './range';

const label = (b, group) => (group === 'month' ? b.start.slice(0, 7) : b.start === b.end ? b.start.slice(5) : `${b.start.slice(5)}–${b.end.slice(5)}`);

export const MoneyTrend = ({ cash, compare, onBin, onAll }) => {
  const data = cash.bins.map(b => ({ ...b, label: label(b, cash.group), in: b.in_cents / 100, out: b.out_cents / 100, prev: b.prev_in_cents / 100 }));
  const pick = (d) => onBin(d?.payload || d);
  return (
    <section className="rounded-[10px] border border-[#e7e4db] bg-[#fffefa] p-4 sm:p-6" data-testid="money-trend">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-[10px] font-bold tracking-[0.1em] text-[#74776a]">RECORDED CASH ACTIVITY</p>
          <h2 className="text-xl sm:text-2xl font-medium tracking-tight text-[#20211d]">Money in. Money out.</h2>
          <p className="text-xs text-[#77776e]">{{ day: 'Daily', week: 'Weekly', month: 'Monthly' }[cash.group]} view · click a bar to see the records behind it</p>
        </div>
        <div className="flex flex-wrap gap-3 text-[11px] text-[#55574e]">
          <span className="flex items-center gap-1.5"><i className="h-2.5 w-2.5 rounded-sm bg-[#7c9263]" />Money in</span>
          <span className="flex items-center gap-1.5"><i className="h-2.5 w-2.5 rounded-sm bg-[#e79155]" />Money out</span>
          {compare && <span className="flex items-center gap-1.5"><i className="h-0.5 w-4 bg-[#536646]" />Previous period money in</span>}
        </div>
      </div>
      <div className="mt-4 h-[260px] cursor-pointer">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={data} margin={{ left: 0, right: 8, top: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e3e8db" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 11, fill: '#8a8c80' }} minTickGap={12} />
            <YAxis tick={{ fontSize: 11, fill: '#8a8c80' }} tickFormatter={v => `$${v}`} width={60} />
            <Tooltip formatter={(v, n) => [money(Math.round(v * 100)), { in: 'Money in', out: 'Money out', prev: 'Previous period in' }[n]]} labelFormatter={(l, p) => (p?.[0] ? `${p[0].payload.start} to ${p[0].payload.end}` : l)} contentStyle={{ borderRadius: 8, border: '1px solid #e4e4e7' }} />
            <Bar dataKey="in" fill="#7c9263" radius={[3, 3, 0, 0]} onClick={pick} data-testid="money-in-bars" />
            <Bar dataKey="out" fill="#e79155" radius={[3, 3, 0, 0]} onClick={pick} />
            {compare && <Line type="monotone" dataKey="prev" stroke="#536646" strokeDasharray="4 3" dot={false} />}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-[11px] text-[#77776e]">
        <span>{cash.start} through {cash.end} · Pacific dates</span>
        <button type="button" onClick={onAll} className="font-semibold text-[#b75b28] hover:underline" data-testid="money-view-all">View underlying records ↗</button>
      </div>
      <p className="mt-2 text-[11px] text-[#8a8c80]" data-testid="money-note">{cash.note}</p>
    </section>
  );
};
